// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import EF from '@everflow/everflow-sdk';

import { LINK_TO_TRACKQUANT } from 'constants/externalLinks';

export const handleEverFlowEvent = (amount: string, order_id?: string) => {
  EF.conversion({
    aid: 514,
    amount,
    order_id,
    tracking_domain: LINK_TO_TRACKQUANT,
    verification_token: import.meta.env.VITE_EVERFLOW_VERIFICATION_TOKEN
  });
};
